import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";

import { Link } from "react-router-dom";
import { apiFolderFileLinks, TOP_WIDE_LOGOK } from "../../../utils";

import { useContext } from "react";
import PsContext from "../../../context";
import { TOP_WIDE_KAM } from "../../../utils";

const HeaderLogo = (props) => {
  const context = useContext(PsContext);

  return (
    <div className="section p-3 d-none d-md-block">
      <div className="container">
        <Row>
          <Col md={12} className="d-none d-md-block">
            <Link to="/">
              <img
                src={apiFolderFileLinks(
                  context.settingValue("web_site_fullsize_logo")
                )}
                className="w-100"
              />
            </Link>
          </Col>
          {/* <Col md={7}>
            <div className="d-flex justify-content-end mb-3">
              <InputGroup size="sm" style={{ width: "250px" }}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="bg-light"
                  placeholder="Quick Finder"
                />
                <InputGroup.Text>
                  <i className="fa-solid fa-magnifying-glass"></i>
                </InputGroup.Text>
              </InputGroup>
            </div>
            <div>
              <ul className="nav justify-content-end top_gray_icons social-icons">
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_youtube")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_facebook")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={context.settingValue("web_site_social_instagram")}
                    target="_blank"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li className="nav-item px-2 fs-5">
                  <a
                    href={`tel:${context.settingValue(
                      "web_site_enquiry_phone"
                    )}`}
                  >
                    <i className="fa-solid fa-phone me-1"></i>
                    {context.settingValue("web_site_enquiry_phone")}
                  </a>
                </li>
              </ul>
            </div>
          </Col> */}
        </Row>
      </div>
    </div>
  );
};

export default HeaderLogo;
